import React, { FC } from 'react';
import classnames from 'classnames';

import styles from './styles.module.css';

export type NpnExternalLinkProps = {
  isAgency?: boolean;
  moveToTop: boolean;
};

export const NpnExternalLink: FC<NpnExternalLinkProps> = ({
  isAgency = false,
  moveToTop = false,
}) => {
  return (
    <div
      className={classnames(
        styles.npnExternalLink,
        moveToTop ? styles.moveTop : ''
      )}
      data-testid="npn-external-link"
    >
      Click{' '}
      <a
        href="https://nipr.com/help/look-up-your-npn"
        target="_blank"
        rel="noreferrer"
      >
        here
      </a>{' '}
      to find your {isAgency ? 'agency' : 'agent'} NPN.
    </div>
  );
};
